<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Update Workflow Status
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Status">
              <b-select
                name="workflow_status"
                v-model="workflow_status"
                expanded
                placeholder="Please select"
                data-cy="bulk-status"
              >
                <option
                  v-for="(option, index) in status"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-primary" @click="submit">
          Update Status
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Abort
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
// @group Reporting Tracker
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    checkedRows: {
      type: Array,
      default: null
    },
    filters: {
      type: String,
      default: null
    },
    checkedAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      workflow_status: null,
      isModalActive: false,
      status: [
        "New",
        "Raw data requested",
        "Raw data received",
        "Work in progress",
        "Awaiting approval",
        "Ready to submit",
        "Correction of data needed",
        "Submitted by customer",
        "No TD from customer",
        "Report not required"
      ],
      reportingTrackerService: new ReportingTrackerDataService()
    };
  },
  methods: {
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    submit() {
      if (this.workflow_status != null) {
        this.reportingTrackerService
          .bulkUpdateWorkflowStatus(
            this.checkedRows.map(records => records.id),
            this.filters,
            this.checkedAll,
            this.workflow_status
          )
          .subscribe(response => {
            if (response["success"]) {
              this.$buefy.dialog.alert({
                title: "Success",
                message: "Workflow Status Updated!"
              });

              this.$emit("viewConfirm", this.workflow_status);
            } else if (response["error"]) {
              const errorSummary = response["error"];
              this.$buefy.dialog.alert({
                title: "Error",
                message: errorSummary
              });
              this.$emit("cancel");
              // this.$emit(
              //   "viewConfirm",
              //   this.workflow_status,
              //   JSON.parse(JSON.stringify(errorSummary))
              // );
            }
          }, this.handleApiError);
      } else {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select status from the list!",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
